import { FormType } from "@/types/form-types";

const typeToTitleMap: Record<FormType, string> = {
  upload: "- Upload taak aanpassen",
  edit: "- Bewerken",
};

export const getTitleAddon = (type: FormType | undefined) =>
  type ? typeToTitleMap[type] : "- Aanmaken";
